const CAMPAIGNS_WITH_LOGO = [ 'prslw' ];

const CAMPAIGN_COLLECTION_LIMIT = 3;

const CAMPAIGN_STATUS = {
  PRE: 'PRE',
  OPEN: 'OPEN',
  POST: 'POST',
};

const LANDINGS_CODES = {
  BLACK_FRIDAY: 'blfr',
  FAMILY_AND_FRIENDS: 'fafr',
  MID_SEASON_SALE: 'mss',
  CYBER_MONDAY: 'cym',
  SINGLE_DAY: 'sid',
  SALES: 'sales',
  ARCHIVE: 'arco',
  PRIVATE_SALE_WOMAN: 'prslw',
};
const CUSTOM_LANDING_CODES = Object.values(LANDINGS_CODES);

module.exports = {
  CAMPAIGNS_WITH_LOGO,
  CAMPAIGN_COLLECTION_LIMIT,
  CAMPAIGN_STATUS,
  CUSTOM_LANDING_CODES,
  LANDINGS_CODES,
};
